const path="/sso/"

export const updateProfile=`${path}UpdateProfile`
export const getProfile=`${path}GetProfile`
export const IsProfileCompleted=`${path}IsProfileCompleted`
export const updateFace=`${path}UpdateFace`
export const checkFace=`${path}CheckFace`
export const deleteSSo=`${path}Delete`
export const verify=`${path}Verify`
export const LogOut=`${path}Logout`
